import { Vec2 } from './vec2';

export interface ParticleOptions {
  position: Vec2;
  velocity: Vec2;
  lifetime: number;
  color: string;
  size: number;
}

class Particle {
  position: Vec2;
  velocity: Vec2;
  lifetime: number;
  age = 0;
  color: string;
  size: number;

  constructor(options: ParticleOptions) {
    this.position = options.position.clone();
    this.velocity = options.velocity.clone();
    this.lifetime = options.lifetime;
    this.color = options.color;
    this.size = options.size;
  }

  update(dt: number): boolean {
    this.position.add(this.velocity.clone().scale(dt));
    this.age += dt;
    return this.age < this.lifetime;
  }

  render(ctx: CanvasRenderingContext2D): void {
    const lifeRatio = 1 - this.age / this.lifetime;
    ctx.globalAlpha = Math.max(0, lifeRatio);
    ctx.fillStyle = this.color;
    ctx.fillRect(this.position.x, this.position.y, this.size, this.size);
    ctx.globalAlpha = 1;
  }
}

export class ParticleSystem {
  private particles: Particle[] = [];

  emit(options: ParticleOptions | ParticleOptions[]): void {
    if (Array.isArray(options)) {
      options.forEach((opt) => this.particles.push(new Particle(opt)));
      return;
    }
    this.particles.push(new Particle(options));
  }

  update(dt: number): void {
    this.particles = this.particles.filter((p) => p.update(dt));
  }

  render(ctx: CanvasRenderingContext2D): void {
    this.particles.forEach((particle) => particle.render(ctx));
  }

  clear(): void {
    this.particles = [];
  }
}
